import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import LoaderText from '../components/loader/LoaderText';
import Error404 from '../pages/error/Error404';
import AdminLayout from '../layout/AdminLayout';
import { NAVIGATE_ADMIN } from '../constant';

const DashboardPage = lazy(() => import('../pages/admin/dashboard'));
const HomePage = lazy(() => import('../pages/admin/home'));
const QuotationPage = lazy(() => import('../pages/admin/quotation'));
const ProformaInvoiceList = lazy(() => import('../pages/admin/proforma-invoice'));
const TaxInvoicePage = lazy(() => import('../pages/admin/tax-invoice'));
const AdminRoute = () => {
    return (
        <Suspense fallback={<AdminLayout><LoaderText /></AdminLayout>}>
            <Routes>
                <Route path='*' element={<AdminLayout><Error404 /></AdminLayout>}></Route>
                <Route path={NAVIGATE_ADMIN.DASHBOARD} element={<AdminLayout><DashboardPage /></AdminLayout>}></Route>
                <Route path={NAVIGATE_ADMIN.HOME} element={<AdminLayout><HomePage /></AdminLayout>}></Route>
                <Route path={NAVIGATE_ADMIN.QUOTATION} element={<AdminLayout><QuotationPage /></AdminLayout>}></Route>
                <Route path={NAVIGATE_ADMIN.PROFORMA_INVOICE} element={<AdminLayout><ProformaInvoiceList /></AdminLayout>}></Route>
                <Route path={NAVIGATE_ADMIN.TAX_INVOICE} element={<AdminLayout><TaxInvoicePage /></AdminLayout>}></Route>
            </Routes>
        </Suspense>
    )
}

export default AdminRoute;